// Destinatarios de una respuesta del Libro: el remitente del mensaje respondido y luego sus demás
// destinatarios, sin repetir partes, sin partes sin id y sin la parte que responde.
// No muta los argumentos.
export const computeReplyRecipients = ({ sender, recipients, replierSectionPartyId }) => {
    const result = [];
    for (const party of [sender, ...(recipients ?? [])]) {
        const sectionPartyId = party?.sectionPartyId;
        if (sectionPartyId === null || sectionPartyId === undefined) continue;
        if (sectionPartyId === replierSectionPartyId) continue;
        if (result.some((added) => added.sectionPartyId === sectionPartyId)) continue;
        result.push({ sectionPartyId, name: party.name });
    }
    return result;
};
